const fedopsLoggerFactory = require('fedops-logger/dist/src/logger-factory')
const createRavenHooksForFedops = require('dbsm-common/src/raven/createRavenHooksForFedops')

const createFedopsLogger = (Raven, inSsrMode) => {
  const { startHook, endHook } = createRavenHooksForFedops(Raven)
  // custom timeoutHook for viewer-app fedops logger. Logs with level info until stabilized, to prevent false alarms
  const timeoutHook = ({ name, timeout }) =>
    Raven.captureMessage(`interaction ${name} timed out`, {
      level: 'info',
      extra: {
        interactionTimeout: timeout
      }
    })

  const fedopsLoggerOptions = {
    interactionTimeout: 50000,
    startHook,
    endHook,
    timeoutHook
  }

  if (inSsrMode) {
    return fedopsLoggerFactory.create(
      'wix-code-dbsm-viewer-app-ssr',
      fedopsLoggerOptions
    )
  } else {
    return fedopsLoggerFactory.create(
      'wix-code-dbsm-viewer-app',
      fedopsLoggerOptions
    )
  }
}

module.exports = createFedopsLogger



// WEBPACK FOOTER //
// ./fedops/createFedopsLogger.js